import { sendRequestJson } from '@/utils'
import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

export class AccountingRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async getAccountingConfig() {
		const url = this.urlBase + '/world/api/accounting-config'
		try {
			const data = {}
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal.')
		}
	}

	async registerAccountingSnapshot(data) {
		const url = this.urlBase + '/world/api/accounting/create-accounting-snapshot'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal.')
		}
	}

	async registerCashDrawerTransaction(data) {
		const url = this.urlBase + '/world/api/accounting/cash-drawer-transaction'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Ups, algo ha ido mal.')
		}
	}

	async getCashDrawerTransactions(body = {}) {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/accounting/cash-drawer-transactions'),
			method: 'POST',
			body,
		})
		return data
	}

	async getCashDrawerTransactionPrint(transactionId) {
		const { data } = await apiRequest({
			url: apiUrl(`/world/api/accounting/cash-drawer-transactions/${transactionId}/print`),
			method: 'GET',
		})
		return data
	}
}

export const accountingRepository = new AccountingRepository()
